import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {Formik} from 'formik';
import * as Yup from "yup";
import clsx from "clsx";
import {
  Button,
  FormikInput,
  validateIfHaveAtLeastLetterRequired,
  validateLegalRut,
  validateRequired
} from "presentation/common";
import {emptyFn} from "presentation/common/helpers/utils";
import {CommonBillForm} from "presentation/new-report/components/common-bill-form/common-bill-form";

import styles from './BillInfoForm.module.scss';

export const BillInfoForm = (props) => {
  const {billInfo, onSubmitAction, onCancelAction} = props;

  const onSubmit = useCallback((values, {setSubmitting}) => {
    if (onSubmitAction != null) {
      // setSubmitting(true);
      onSubmitAction(values.billInfo);
    }
  }, []);

  return (
    <Formik
      initialValues={{billInfo}}
      validationSchema={
        Yup.object().shape({
          billInfo: Yup.object().shape({
            rut: validateLegalRut,
            businessType: validateIfHaveAtLeastLetterRequired("razón social"),
            economicActivity: validateIfHaveAtLeastLetterRequired("actividad económica"),
            address: validateRequired("La dirección es requerida."),
          })
        })
      }
      onSubmit={onSubmit}>
      {
        (formik) => {
          const {
            setFieldValue,
            setFieldTouched,
            isSubmitting,
            handleSubmit
          } = formik;

          return (
            <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
              <CommonBillForm
                name='billInfo'
                setFieldTouched={setFieldTouched}
                setFieldValue={setFieldValue}/>

              <FormikInput
                required
                label="Dirección"
                placeholder="Calle, Número, Comuna"
                name="billInfo.address"/>

              <div className={clsx(styles.buttonActions, 'p-2')}>
                <Button label="Cancelar" onClick={onCancelAction} theme="outline" className="mr-2"/>
                <Button type="submit" label="Guardar" disabled={isSubmitting}/>
              </div>
            </form>
          )
        }
      }
    </Formik>
  )
};

BillInfoForm.propTypes = {
  billInfo: PropTypes.object,
  onSubmitAction: PropTypes.func,
  onCancelAction: PropTypes.func,
}

BillInfoForm.defaultProps = {
  billInfo: {},
  onCancelAction: emptyFn
}

export default React.memo(BillInfoForm);
